    window.lm = window.lm || {};
	window.lm.constants = window.lm.constants || {};
	switch(globalSiteSettings.currentLanguage) {
		case 'es':
			window.lm.constants.ApplicationUrl = window.lm.constants.ApplicationUrl || globalSiteSettings.www2Url+'spanish-landing/application';
			break;
		default:
			window.lm.constants.ApplicationUrl = window.lm.constants.ApplicationUrl || globalSiteSettings.www2Url+'application/application.asp';
			break;
	}

    $(document).ready(function () {
        var validationText = {
            FirstNameNotSpecified: 'First Name is not specified.',
            FirstNameCharacterWarning: 'First Name can only consist of alphabetical and space.',
            LastNameNotSpecified: 'Last Name is not specified.',
            LastNameCharacterWarning: 'Last Name can only consist of alphabetical and space.',
            EmailNotSpecified: 'Email address is not specified.',
            EmailInvalid: 'Email address is invalid.',
            SelectState: 'Please select a state.',
            SelectCar: 'This field is required.',
            SelectTerms: 'You must agree to our terms \u0026 conditions.',
            SelectESignConsent: 'You must agree to our terms \u0026 Conditions.',
            NoCar: {
                Text: 'If you do not own a vehicle, LoanMart may be able to help you with a personal loan.',
                VisitPersonalButton: 'Visit the LoanMart personal loan page.',
                IHaveCarButton: 'Wait, I have a car. Take me back.'
            },
            DuplicateLeadText: 'An application with your email address is already on file with LoanMart. Please call us at \u003ca href=\u0027tel:1-855-422-7412\u0027 class=\u0027a_standalone text-strong lm-page-settings\u0027 data-lmsettings=\u0027phone\u0027\u003e\u003cspan class=\u0027lm-page-settings\u0027 data-lmsettings=\u0027phone\u0027\u003e1-855-422-7412\u003c/span\u003e\u003c/a\u003e to finalize your application and get your cash.'
        };
        LMApplicationRedirectModule(validationText);
    });

